import { COUNTRIES_WITH_ENORMOUS_PRICE } from 'constants/countriesList';

import { isCountryWithEnormousPriceType } from './types';

export const isCountryWithEnormousPrice: isCountryWithEnormousPriceType = (country) =>
    COUNTRIES_WITH_ENORMOUS_PRICE.includes(country);
